import { useEffect, useMemo } from 'react'
import { parseParams } from '../utils'
import { useNextHistory } from './useNextHistory'
import { QUERY_PARAM_VALUE_DIVIDER, UPDATE_ROUTER_MODE_REPLACE, UPDATE_ROUTER_MODE_PUSH } from '../constants'
import isEqual from 'lodash/isEqual'

export const useUpdateQueryParams = ({ params, disabled = false, mode = UPDATE_ROUTER_MODE_REPLACE }) => {
	const { replace, push } = useNextHistory()

	const updateHandler = useMemo(
		() => (mode === UPDATE_ROUTER_MODE_REPLACE ? replace : mode === UPDATE_ROUTER_MODE_PUSH ? push : () => {}),
		[mode, push, replace]
	)

	useEffect(() => {
		if (!disabled) {
			const currentQuery = parseParams(document.location.search)
			const newQuery = { ...currentQuery }

			Object.entries(params).forEach(([key, value]) => {
				if (value && value?.length) {
					newQuery[key] = Array.isArray(value) ? value.join(QUERY_PARAM_VALUE_DIVIDER) : value
				} else {
					delete newQuery[key]
				}
			})

			if (!isEqual(currentQuery, newQuery)) {
				updateHandler(
					{
						pathname: window.location.pathname, // keep the same
						hash: window.location.hash, // keep it, if exists
						query: newQuery,
					},
					null,
					{
						shallow: true, // update the path of the current page without rerunning
						silent: true,
					}
				)
			}
		}
	}, [params, disabled, updateHandler])
}
